import { render, staticRenderFns } from "./local-qris.vue?vue&type=template&id=207a427b&scoped=true"
import script from "./local-qris.vue?vue&type=script&lang=js"
export * from "./local-qris.vue?vue&type=script&lang=js"
import style0 from "./local-qris.vue?vue&type=style&index=0&id=207a427b&prod&lang=scss&scoped=true"
import style1 from "./local-qris.vue?vue&type=style&index=1&id=207a427b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a427b",
  null
  
)

export default component.exports